import { gql } from '@apollo/client'
import { COORDINATES_FRAGMENT } from './CoordinatesFragment'

export const BASE_BOUNDING_BOX_OBJECT_FRAGMENT = gql`
  fragment BaseBoundingBoxObject on BoundingBoxObjectType {
    id
    label
    groupId
    coordinates {
      ...CoordinatesFragment
    }
  }
  ${COORDINATES_FRAGMENT}
`
